import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * NavActiveSync — marks the nav link matching the current route as active
 * (aria-current="page" + .nav-active), so the dark header highlights the
 * current page. The nav itself stays 100% data-driven YAML
 * (Navigation.yaml Switch over Drupal menus); this only ADDS the active marker
 * via the DOM, so if it ever fails the nav still renders normally (graceful).
 *
 * Menu links load asynchronously (decoupled API), so we re-mark a few times
 * after each route change to catch them once they appear.
 */
const SELECTOR = '.orbit-shell-header nav a[href]';

function markActive() {
  const path = window.location.pathname;
  document.querySelectorAll(SELECTOR).forEach((a) => {
    const href = a.getAttribute('href') || '';
    if (!href.startsWith('/')) return;
    const active = href === '/' ? path === '/' : (path === href || path.startsWith(href + '/'));
    if (active) {
      a.setAttribute('aria-current', 'page');
      a.classList.add('nav-active');
    } else {
      a.removeAttribute('aria-current');
      a.classList.remove('nav-active');
    }
  });
}

export function NavActiveSync() {
  const location = useLocation();
  useEffect(() => {
    markActive();
    const timers = [80, 300, 800, 1600].map((t) => setTimeout(markActive, t));
    return () => timers.forEach(clearTimeout);
  }, [location.pathname]);
  return null;
}

export default NavActiveSync;
